export default "__VITE_ASSET__BhJVPhTj__"